import React, { Component } from 'react';
import { Row, Col, Button, Dropdown, MenuItem } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

export class BatchesModal2 extends Component {
  constructor() {
    super();
    this.state = {
      selectedBatch: {
        label: 'default',
        value: null,
        expire: null,
      },
      batchSelection: [],
      outputExpire: null,
    };
    // this.moveNotIncluded = this.moveNotIncluded.bind(this);
  }

  componentDidMount() {
    let { selectedBatch } = this.state;
    // this.props.batchesInfo.batches.map(r=>{
    //     if (r.id === this.props.lineBatchId) {
    //         selectedBatch.label = `${r.expire_datetime ? `Expired: ${new Date(r.expire_datetime).toLocaleString().split(',')[0]}` : ''}  ${r.batch_num}: ${r.quantity}`;
    //         selectedBatch.value = r.id;
    //     }
    // });
    this.setState({
      // batchSelection: this.processBatchSelection(this.props.batchesInfo.batches),
      selectedBatch
    })
  }

  componentWillReceiveProps(nextProps) {
    let {selectedBatch} = this.state;
    // if (this.props.batchesInfo !== nextProps.batchesInfo) {
    nextProps.batchesInfo && nextProps.batchesInfo.batches && nextProps.batchesInfo.batches.map(r=>{
      if (r.id === this.props.lineBatchId) {
        selectedBatch.label = `${r.expire_datetime ? `Expired: ${new Date(r.expire_datetime).toLocaleString().split(',')[0]}` : ''}  ${r.batch_num}: ${r.quantity} (${r.location})`;
        selectedBatch.value = r.id;
        selectedBatch.expiredDate = r.expire_datetime;
        selectedBatch.location = r.location;
      }
    });

    this.setState({
      batchSelection: this.processBatchSelection(nextProps.batchesInfo.batches),
      selectedBatch
    })
    //   }
  }

  processBatchSelection = (baches = []) => {
    let avaliableBatches = baches.filter(batch => {
    //   if (batch.quantity <= 0 && !this.props.salesOrderProduct.IsOverSaleable) {
    //     return false;
    //   }
      return true;
    });
    // avaliableBatches = avaliableBatches.sort((a, b) => {
    //   if (a.expire_datetime > b.expire_datetime) {
    //     return 1
    //   }
    //   return -1
    // });
    avaliableBatches = avaliableBatches.map(batch => ({ label: `${batch.expire_datetime ? `Expired: ${new Date(batch.expire_datetime).toLocaleString().split(',')[0]}` : ''}  ${batch.batch_num}: ${batch.quantity} (${batch.location})`, value: batch.id, expiredDate: batch.expire_datetime, location: batch.location }));
    return avaliableBatches;
  }

  handleBatchSelected = (selectedBatch) => this.setState({ selectedBatch });

  handleOnSubmit = (e) => {
    const { selectedBatch, outputExpire } = this.state;
    const { lineBatchRows } = this.props;

    this.props.lineBatchRows.map((r,index)=>{
      if (r.Index === this.props.lineBatchIdx) {
        lineBatchRows[index].Batch_id_id = selectedBatch.value;
        lineBatchRows[index].Batch_id = selectedBatch.value;
        lineBatchRows[index].BatchExpiredDate = selectedBatch.expiredDate;
        lineBatchRows[index].BatchLocation = selectedBatch.location;
      }
    });

    this.props.onEditBatch(this.props.lineBatchRows);
    // const batch = selectedBatch.value ? selectedBatch : this.state.batchSelection[0];
    // this.props.onSelectedBatch(batch.value, batch.expiredDate);
  };


  render() {
    const { selectedBatch } = this.state;

    return (
      <div>
        <Row style={{ marginBottom: '12px' }}>
          <Col sm={2}>
            <label style={{ float: 'right' }}>
              <Translate value="select_batch" />:
            </label>
          </Col>
          <Col sm={10}>
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: '450px',
                  backgroundColor: 'white',
                  border: '1px solid #555555',
                  color: 'black',
                  fontWeight: '400',
                }}
              >
                {selectedBatch.label || selectedBatch}
              </Dropdown.Toggle>
              <Dropdown.Menu
                className="super-colors"
                style={{
                  height: '400px',
                  overflowY: 'scroll',
                }}
              >
                {this.state.batchSelection.map((batch) => {
                  return (
                    <MenuItem
                      onClick={() => this.handleBatchSelected(batch)}
                      style={{
                        width: '400px',
                        backgroundColor: 'white',
                        color: 'black',
                        fontWeight: '400',
                      }}
                    >
                      {batch.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: '50px' }}>
          <Button
            bsStyle="success"
            onClick={(e) => {
              this.handleOnSubmit(e);
            }}
          // disabled={!this.state.selectedDriver}
          >
            <Translate value="edit_this_batch" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default BatchesModal2;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/BatchesModal2.jsx